<span *ngIf="!picto.url || picto.url === ''" class="label label-rounded label-success">{{ picto.label }}</span>
<img *ngIf="picto.url && picto.url !== ''" [src]="env.baseFileUrl + picto.url + extension" [alt]="picto.label">
